import { TrackPageViewContainer } from '../../common/containers/TrackPageViewContainer';
import { AppDownloadContainer } from '../../domain/appdownload/container/AppDownloadContainer';
export default function AppDownloadPage() {
  return <>
      <AppDownloadContainer />
      <TrackPageViewContainer trackObj={{
      section: '앱다운로드',
      page: '앱다운로드',
      actionType: 'Pageview',
      actionName: '앱다운로드_화면',
      customProps: {
        user_action: 'pv'
      }
    }} />
    </>;
}